module.exports = __webpack_public_path__ + "img/cate-icon-1.ecc4be28.png";